import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import GridContainer from '../../../../@jumbo/components/GridContainer';
import PageContainer from '../../../../@jumbo/components/PageComponents/layouts/PageContainer';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import { Typography } from '@material-ui/core';
import IntlMessages from '../../../../@jumbo/utils/IntlMessages';
import { lighten, makeStyles } from '@material-ui/core/styles';
import { Card } from '@material-ui/core';
import DataTable from 'react-data-table-component';
import Action from './action';
import Button from '@material-ui/core/Button';
import { Add, AssignmentTurnedIn, Edit, Delete, NavigateNext, NavigateBefore } from '@material-ui/icons';
import LinearProgress from '@material-ui/core/LinearProgress';
import memoize from 'memoize-one';
import { firestore } from 'firebase';
import DatabaseService from '../../../../services/database';
import Api from 'services/api.service';
import { usePagination } from 'use-pagination-firestore';
import { fetchFilter, fetchSearch } from 'redux/actions/Search';

const breadcrumbs = [
  { label: 'Home', link: '/' },
  { label: 'Sample Page', isActive: true },
];

const customStyles = {
  headRow: {
    style: {
      backgroundColor: '#EFEFEF',
    },
  },
};

const columns = memoize((handleApprove, handleEdit, handleDelete, checkPermission) => [
  {
    cell: row =>
      checkPermission(row.type) && <AssignmentTurnedIn onClick={() => handleApprove(row)} style={{ cursor: 'pointer' }} />,
    allowOverflow: true,
    button: true,
    width: '36px',
  },
  {
    cell: row => checkPermission(row.type) && <Edit onClick={() => handleEdit(row)} style={{ cursor: 'pointer' }} />,
    allowOverflow: true,
    button: true,
    width: '36px',
  },
  {
    cell: row => checkPermission(row.type) && <Delete onClick={() => handleDelete(row)} style={{ cursor: 'pointer' }} />,
    allowOverflow: true,
    button: true,
    width: '36px',
  },
  {
    name: 'Email',
    selector: 'email',
    sortable: true,
  },
  {
    name: 'Name',
    selector: 'name',
    sortable: true,
  },
  {
    name: 'Phone',
    selector: 'mobile',
    sortable: true,
  },
  {
    name: 'Line',
    selector: 'line_id',
    sortable: true,
  },
  {
    name: 'Customer',
    selector: 'customer_id',
    sortable: true,
  },
  {
    name: 'Sub',
    selector: 'sub_id',
    sortable: true,
  },
  {
    name: 'Type',
    selector: 'type',
    sortable: true,
  },
]);

const useStyles = makeStyles(theme => ({
  card: {
    margin: '0 auto',
    padding: 10,
    backgroundColor: lighten('#FFFFFF', 0.1),
    width: '100%',
    // backgroundColor: lighten(theme.palette.background.paper, 0.1),
  },
  table: {
    width: '100%',
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },
}));

const LinearIndeterminate = () => {
  const classes = useStyles();

  return (
    <div className={classes.table}>
      <LinearProgress />
    </div>
  );
};

const Registration = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const fetchData = () => {
    dispatch(DatabaseService.getAllCustomers());
    dispatch(DatabaseService.getAllSub());
  };
  const { authUser } = useSelector(({ auth }) => auth);
  const { searchText } = useSelector(({ search }) => search);
  const { filterSearch } = useSelector(({ search }) => search);
  const [open, setOpen] = useState(false);
  const [data, setData] = useState([]);
  const [pending, setPending] = useState(false);
  const [selectedUser, setSelectedUser] = useState();
  const [typeAction, setTypeAction] = useState();

  const { items, isLoading, isStart, isEnd, getPrev, getNext } = usePagination(
    DatabaseService.fetchManagementData({
      authUser: authUser,
      collections: 'registered_users',
      filterSearch: filterSearch,
      searchText: searchText,
    }),
    // firestore.collection("/registered_users").orderBy("email", "asc"),
    {
      limit: 20,
    },
  );

  const handleDialog = () => {
    setTypeAction();
    setSelectedUser();
    setOpen(false);
  };

  const handleApprove = row => {
    setTypeAction('approval');
    setSelectedUser(row);
    setOpen(true);
  };

  const handleEdit = row => {
    setTypeAction('edit');
    setSelectedUser(row);
    setOpen(true);
  };

  const handleDelete = row => {
    setTypeAction('delete');
    setSelectedUser(row);
    setOpen(true);
  };

  // const getAllRegister = async () => {
  //     setPending(true);

  //     const ref = firestore.collection('registered_users');
  //     ref.onSnapshot(snapShot => {
  //         let tempDataArray = [];
  //         snapShot.forEach(doc => {
  //             if (doc.exists) {
  //                 tempDataArray = [
  //                     ...tempDataArray,
  //                     {
  //                         uid: doc.id,
  //                         email: doc.data().email,
  //                         password: doc.data().password,
  //                         name: doc.data().name,
  //                         mobile: doc.data().mobile,
  //                         line_id: doc.data().line_id,
  //                         customer: doc.data().customer_id ?? '',
  //                         customer_id: doc.data().customer_id ?? '',
  //                         type: doc.data().type,
  //                     },
  //                 ];
  //             }
  //         });
  //         setData(tempDataArray);
  //         setPending(false);
  //     });
  // }

  // useEffect(() => {
  //     getAllRegister();
  // }, []);

  const checkPermission = type => {
    switch (authUser.type) {
      case 'admin':
        if (type !== 'superadmin') {
          return true;
        }
        break;
      case 'superadmin':
        return true;
      default:
        return false;
    }
  };

  useEffect(() => {
    fetchData();

    dispatch(fetchSearch(''));
    dispatch(
      fetchFilter([
        { key: 'name', name: 'Name' },
        { key: 'email', name: 'Email' },
        { key: 'customer_id', name: 'Customer Id' },
        { key: 'type', name: 'Type' },
      ]),
    );
  }, []);

  return (
    <GridContainer>
      <Grid item xs={4} container justifyContent="flex-start">
        <Typography variant="h2">
          <IntlMessages id="page.registrationManagement" />
        </Typography>
      </Grid>
      <Grid item xs={4}></Grid>

      <Grid item xs={4} container justifyContent="flex-end">
        <Button variant="contained" color="secondary" onClick={() => setOpen(true)}>
          <Add /> Create New User
        </Button>
      </Grid>

      <Grid item xs={12}>
        <Box>
          <Card className={classes.card}>
            <DataTable
              noHeader
              title="Registration Management"
              columns={columns(handleApprove, handleEdit, handleDelete, checkPermission)}
              data={items}
              // selectableRows
              progressPending={isLoading}
              progressComponent={<LinearIndeterminate />}
              customStyles={customStyles}
            />
            {open && <Action open={open} handleDialog={handleDialog} selectedUser={selectedUser} typeAction={typeAction} />}
          </Card>
          <Grid container justifyContent="flex-end" spacing={5} style={{ marginTop: 5 }}>
            <Grid item>
              <Button variant="contained" color="secondary" onClick={getPrev} disabled={isStart}>
                <NavigateBefore /> Previous
              </Button>
            </Grid>

            <Grid item>
              <Button variant="contained" color="secondary" onClick={getNext} disabled={isEnd}>
                Next <NavigateNext />
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Grid>
    </GridContainer>
  );
};

export default Registration;
